import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col w-full min-h-full bg-gray-50 text-gray-800 font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex flex-col w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Solution data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Guarantee data-id="element-7" />
        <CTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}